import { XsltTemplate } from './ApiType';

// eslint-disable-next-line import/prefer-default-export
export const mockGetXsltTemplates: XsltTemplate[] = [{
  name: 'Heureka',
  definition: ''
        + '<?xml version="1.0" encoding="UTF-8"?>\n'
        + '<MARKETPLACE>\n'
        + '    <PRODUCT>\n'
        + '        <ID>12345</ITEM_ID>\n'
        + '        <PRICE>100</PRICE_VAT>\n'
        + '        <EAN>EAN12345</EAN>\n'
        + '    </PRODUCT>\n'
        + '</MARKETPLACE>\n'
        + '</xml>',
},
{
  name: 'Price',
  definition: ''
            + '<?xml version="1.0" encoding="UTF-8"?>\n'
            + '<MARKETPLACE>\n'
            + '    <PRODUCT>\n'
            + '        <ID>123456</ITEM_ID>\n'
            + '        <PRICE>100</PRICE_VAT>\n'
            + '        <EAN>EAN12345</EAN>\n'
            + '    </PRODUCT>\n'
            + '</MARKETPLACE>\n'
            + '</xml>',
}];
